import { useSyncExternalStore } from "react";

import { getUiMode, isEventUIEnabled, subscribeUiMode } from "@/lib/event-config";
import { themeOf, type EventTheme, type UiMode } from "@/lib/events/registry";

/**
 * Chế độ giao diện đang bật, có PHẢN ỨNG khi máy chủ trả lời.
 *
 * 🔴 **Component phải dùng hook này, đừng gọi thẳng `isEventUIEnabled()`.** Giá trị
 * đổi GIỮA CHỪNG — lúc `loadUiMode()` nhận câu trả lời. Gọi hàm trần trong render thì
 * React không biết có gì đổi, nên trang giữ nguyên giao diện cũ cho tới lần render kế
 * tiếp vì một lý do nào khác — hỏng lác đác, không lỗi nào hiện ra.
 *
 * `getServerSnapshot` trả đúng snapshot của client vì store được seed đồng bộ ngay
 * lúc module nạp (cache localStorage → biến môi trường).
 */
export function useUiMode(): UiMode {
  return useSyncExternalStore(subscribeUiMode, getUiMode, getUiMode);
}

/** Đúng khi một giao diện sự kiện bất kỳ đang bật. */
export function useEventUI(): boolean {
  return useSyncExternalStore(subscribeUiMode, isEventUIEnabled, isEventUIEnabled);
}

/**
 * Chủ đề của dịp lễ đang bật, hoặc `null` ở giao diện thường.
 *
 * Đây là thứ component nên dùng: một phép kiểm `null` vừa cho biết có đang ở giao
 * diện sự kiện hay không, vừa đưa luôn asset và nội dung thẻ — thay vì một boolean
 * rồi phải tra bảng ở chỗ khác.
 */
export function useEventTheme(): EventTheme | null {
  return themeOf(useUiMode());
}
